import { useGeneralStore } from "%/stores/general-store";
import { PAGE_MARKETPLACE, SECTION_ONBOARDING } from "@/constants/nav-constants";
import { useFeatureStore } from "%/stores/feature-store";
import { waitlistStatus } from "@/enums/waitlist-enum";

function filterMenuItems(menuItems, stripIcons = false) {
  const filteredNavItems = [];
  const orgWaitlistStatus = useGeneralStore().orgData.waitlist_status;
  const organisationCapabilities = useGeneralStore().orgCapabilities;
  const isSyndicationMarketplaceEnabled = useFeatureStore().isFeatureEnabled("syndicationMarketplace");

  menuItems.forEach(menuItem => {
    if (menuItem.name === PAGE_MARKETPLACE) {
      if (!isSyndicationMarketplaceEnabled) {
        return;
      }
    }

    if (menuItem.name === SECTION_ONBOARDING) {
      if (orgWaitlistStatus === waitlistStatus.creatorApproved) {
        return;
      }
    }

    if (menuItem.requiredCapabilities && menuItem.requiredCapabilities.length > 0) {
      menuItem.requiredCapabilities.forEach(capability => {
        if (!organisationCapabilities.includes(capability)) {
          return;
        }

        const isApprovedCreator = orgWaitlistStatus === waitlistStatus.creatorApproved;
        if (menuItem.requiresCreatorApproval && !isApprovedCreator) {
          return;
        }

        filteredNavItems.push(menuItem);
      });
    } else {
      filteredNavItems.push(menuItem);
    }
  });

  if (!stripIcons) {
    return filteredNavItems;
  }

  return filteredNavItems.map(item => ({ ...item, icon: "" }));
}

export {
  filterMenuItems,
};
